/**
 * Minimal Node `crypto` shim for browser builds (IBE vendor uses randomBytes).
 */
export function randomBytes(size) {
  const out = new Uint8Array(size);
  crypto.getRandomValues(out);
  return out;
}

export default { randomBytes };
